import React from "react";

export const LogoMark = ({ className = "", height = 40 }) => (
  <svg
    viewBox="0 0 60 72"
    height={height}
    width={(height * 60) / 72}
    className={className}
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="bt-silver" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#E9E9EC" />
        <stop offset="45%" stopColor="#9CA0A6" />
        <stop offset="100%" stopColor="#5B5E63" />
      </linearGradient>
      <linearGradient id="bt-platinum" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#FFFFFF" />
        <stop offset="50%" stopColor="#D9D9DC" />
        <stop offset="100%" stopColor="#A7A7AC" />
      </linearGradient>
      <linearGradient id="bt-gold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#F3D58B" />
        <stop offset="45%" stopColor="#C9A24B" />
        <stop offset="100%" stopColor="#8A6A22" />
      </linearGradient>
    </defs>
    <polygon points="9,30 18,30 13,70 4,70" fill="url(#bt-silver)" />
    <polygon points="27,16 36,16 31,70 22,70" fill="url(#bt-platinum)" />
    <polygon points="45,2 54,2 49,70 40,70" fill="url(#bt-gold)" />
  </svg>
);

export const Logo = ({ stacked = false, height = 40, className = "" }) => {
  if (stacked) {
    return (
      <div className={`flex flex-col items-center ${className}`}>
        <LogoMark height={height} />
        <div className="mt-3 text-center">
          <div className="font-serif tracking-[0.25em] text-[#F5F5F0] leading-tight" style={{ fontSize: height * 0.42 }}>
            BLACKTHORNE
          </div>
          <div className="flex items-center justify-center gap-2 mt-1">
            <span className="h-px w-6 bg-[#C9A24B]/60" />
            <span className="font-serif tracking-[0.35em] text-[#C9A24B]" style={{ fontSize: height * 0.34 }}>
              STRATTON
            </span>
            <span className="h-px w-6 bg-[#C9A24B]/60" />
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <LogoMark height={height} />
      <div className="leading-none">
        <div className="font-serif tracking-[0.22em] text-[#F5F5F0]" style={{ fontSize: height * 0.34 }}>
          BLACKTHORNE
        </div>
        <div className="font-serif tracking-[0.3em] text-[#C9A24B] mt-1" style={{ fontSize: height * 0.26 }}>
          STRATTON
        </div>
      </div>
    </div>
  );
};

export default Logo;
